export default __webpack_public_path__ + "static/media/csnpwdtNFI.5b149b4a.ttf";